new Vue({
    el:'#diy',
    data(){
        return{
            products:[
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/PRO.png',name:'XLIM PRO'},
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/pro-2.png',name:'XLIM PRO 2'},
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/GO.png',name:'XLIM GO'},
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SQ-PRO.png',name:'XLIM SQ PRO'},
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME.png',name:'VPRIME'},
                {img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM_db3e82ef-a729-4f6f-ba76-292050b7dfd9.png',name:'NeXLIM'}
            ],
            products_color:[
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/PRO_6bb991dc-8fb9-4450-9d77-062538df02e5.png?v=1732177558',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/PRO-2_0cf09826-d4b3-4e6c-9ac3-feeaab1dfb80.png?v=1732177557',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/GO_ed89ad8c-51e5-4d33-85e3-e5f3346eb545.png?v=1732177557',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SQ-PRO_3d92e457-34a3-44d3-8f2a-d3011b0f2e2f.png?v=1732177558',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VRIME.png?v=1732177558',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM_d1f8e815-16b4-41c8-b363-a97d58a9abbc.png?v=1732177558',
            ],
            // 贴片原始图
            product_mask:[
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_mask.avif?v=1732504156',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_mask.avif?v=1732263892',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_mask.avif?v=1732263892',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_mask.avif?v=1732263892',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_mask.avif?v=1732263892',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_mask.avif?v=1732263892'
            ],
            products_cover:[
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_16.avif'
                    }
                ],
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_16.avif'
                    }
                ], 
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_16.avif'
                    }
                ], 
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_16.avif'
                    }
                ], 
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_16.avif'
                    }
                ], 
                [
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_1.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_2.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_3.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_4.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_5.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_6.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_7.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_8.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_9.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_10.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_11.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_12.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_13.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_14.avif'
                    },
                    {   img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_15.avif',
                        icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_16.avif'
                    }
                ]
            ],
            product:3,
            color:'#2d01ec',
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            popup:false,
            loginPopup:false,
            rulePopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
            },
            loginFlag:false,
            uploadFlag:false,
            downloadFlag:false,
            popup1:false,
            select_flag1:0,
            countryArr:[],
            findText:'',
            coverIndex:-1,
            file:[],
            uploadImg:'',
            imgStyle:true,
            isfileShow:false,
            imagePosition: { x: 0, y: 0 }, // 图片的位置
            startDragPosition: { x: 0, y: 0 }, // 拖拽开始的位置
            isDragging: false, // 是否正在拖拽
            scale: 1, // 当前缩放比例
            minScale: 1, // 最小缩放比例
            maxScale: 5, // 最大缩放比例
            lastTouchDistance: 0, // 双指缩放时记录两指的初始距离
            isMouseInside: false, // 标志鼠标是否在容器内
            serveLink:'',
            dnTest:false,
            // 鼠标点击下标
            box1ActiveIndex:-1,
            // 是否在执行动画
            box1Flag:false,
            // 返回动画执行完成标识
            moveFlag:true,
            // 鼠标移入下标
            hoverIndex:-1,
            // 移动端控制页面显示
            MdiyShow1:true,
            MdiyShow2:true,
            //是否上传完成
            isUpload:true,
            // 是否点击下载
            isClickDownload:false
        }
    },
    methods:{
        // 选择产品后进入DIY
        moveProduct(i){
            this.product=this.box1ActiveIndex=i;this.box1Flag=true
            $('.pbox2').css({zIndex:'6'})
            setTimeout(() => {
                $('.pbox2').css({opacity:1})
            }, 1000);
        },
        // 返回选择产品
        returnMove(i){
            if(i==1){
                this.moveFlag = this.isfileShow = false
                this.coverIndex = -1
                this.uploadImg = ''
                $('.pbox2').css({opacity:0})
                setTimeout(() => {
                    this.box1ActiveIndex=-1;this.box1Flag=false
                    $('.pbox2').css({zIndex:1})
                    setTimeout(() => {
                        this.moveFlag = true
                    }, 1000);
                }, 1000);
            }else if(i==2){
                this.MdiyShow1 = true
                this.MdiyShow2 = false

                this.isfileShow = false
                this.coverIndex = -1
                this.uploadImg = ''
            }
            
        },
        // 开始拖动
        startDrag(event) {
            event.preventDefault();
    
            const startX = event.type === "mousedown" ? event.clientX : event.touches[0].clientX;
            const startY = event.type === "mousedown" ? event.clientY : event.touches[0].clientY;
    
            this.startDragPosition = { x: startX, y: startY };
            this.isDragging = true;
    
            window.addEventListener("mousemove", this.drag);
            window.addEventListener("mouseup", this.stopDrag);
            window.addEventListener("touchmove", this.drag);
            window.addEventListener("touchend", this.stopDrag);
        },
        // 拖动
        drag(event) {
            if (!this.isDragging) return;
    
            const currentX = event.type === "mousemove" ? event.clientX : event.touches[0].clientX;
            const currentY = event.type === "mousemove" ? event.clientY : event.touches[0].clientY;
    
            const deltaX = currentX - this.startDragPosition.x;
            const deltaY = currentY - this.startDragPosition.y;
    
            this.startDragPosition = { x: currentX, y: currentY };
    
            const image = this.$refs.image;
            const container = this.$refs.container;
            // const imageRect = image.getBoundingClientRect();
            // const containerRect = container.getBoundingClientRect();
    
            let newX = this.imagePosition.x + deltaX;
            let newY = this.imagePosition.y + deltaY;


            // 限制边界
            // newX = Math.min(0, Math.max(newX, containerRect.width - imageRect.width));
            // newY = Math.min(0, Math.max(newY, containerRect.height - imageRect.height));
     
            this.imagePosition = { x: newX, y: newY };
        },
        // 停止拖动
        stopDrag() {
            this.isDragging = false;
            window.removeEventListener("mousemove", this.drag);
            window.removeEventListener("mouseup", this.stopDrag);
            window.removeEventListener("touchmove", this.drag);
            window.removeEventListener("touchend", this.stopDrag);
        },
        // 鼠标滚轮缩放
        handleWheel(event) {
            if (!this.isMouseInside) return;
            if (this.uploadImg =='') return; // 仅在鼠标移入容器且上传了图片时触发
            event.preventDefault();
            event.stopPropagation();
            const scaleChange = event.deltaY > 0 ? -0.1 : 0.1;
            this.updateScale(this.scale + scaleChange, event.clientX, event.clientY);
        },
        // 双指缩放
        handleTouchMove(event) {
            if (event.touches.length !== 2) return;
    
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
    
            const currentDistance = Math.hypot(
            touch2.clientX - touch1.clientX,
            touch2.clientY - touch1.clientY
            );
    
            if (this.lastTouchDistance) {
            const scaleChange = (currentDistance - this.lastTouchDistance) / 200;
            this.updateScale(this.scale + scaleChange, 
                            (touch1.clientX + touch2.clientX) / 2, 
                            (touch1.clientY + touch2.clientY) / 2);
            }
    
            this.lastTouchDistance = currentDistance;
        },
        // 更新缩放比例
        updateScale(newScale, centerX, centerY) {
            newScale = Math.min(this.maxScale, Math.max(this.minScale, newScale));
    
            const image = this.$refs.image;
            const container = this.$refs.container;
            const imageRect = image.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
    
            const offsetX = (centerX - containerRect.left) / this.scale;
            const offsetY = (centerY - containerRect.top) / this.scale;
    
            this.imagePosition.x -= offsetX * (newScale - this.scale);
            this.imagePosition.y -= offsetY * (newScale - this.scale);
    
            this.scale = newScale;
    
            const scaledWidth = imageRect.width * (newScale / this.scale);
            const scaledHeight = imageRect.height * (newScale / this.scale);
    
            this.imagePosition.x = Math.min(0, Math.max(this.imagePosition.x, containerRect.width - scaledWidth));
            this.imagePosition.y = Math.min(0, Math.max(this.imagePosition.y, containerRect.height - scaledHeight));
        },
        //下载图片
        async captureScreenshot() {
            this.isClickDownload = true
            // 是否上传完成
            if(this.isUpload){
                // 是否下载完成
                if(!this.downloadFlag){
                    showMessage('Downloading, please wait. . .','success')
                    setTimeout(async () => {
                        this.downloadFlag = true
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify({
                            productIndex:this.product,
                            coverIndex:this.coverIndex,
                            isfileShow:this.isfileShow,
                            uploadImg:this.serveLink,
                            imgStyle:this.imgStyle,
                            imagePosition:this.imagePosition,
                            scale:this.scale,
                            color:this.color
                        }));
                        let res = await axios.post('https://service.oxvatech.cn/diy/screenshot',params);
                        if(res.status == 200){
                            // 下载截图
                            const link = document.createElement('a');
                            link.href = `data:image/png;base64,${res.data.image}`;
                            link.download = 'YOUR_OXVA_YOUR_WAY.png';
                            link.click(); 
                            this.downloadFlag = this.isClickDownload = false
                            this.file = []
                        }else{
                            //出错
                            this.downloadFlag = false
                            showMessage('service error','error')
                        }
                    }, 100);
                }else{
                    showMessage('Downloading, please wait. . .','success')
                }
            }else{
                showMessage('Downloading, please wait. . .','success')
            }
        },
        //上传图片
        uploadFile(event){
            if(!this.uploadFlag){
                var file = event.target.files[0]
                if(file.size>5*1024*1024){
                    showMessage('The uploaded file cannot exceed 4M','error')
                    this.$refs.fileInput.value = "";
                    return;
                }else{
                    var that = this
                    this.uploadFlag=false
                    this.isfileShow = true
                    this.compressImage(event)
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        that.uploadImg = e.target.result; // 将图片的 base64 数据设为 img 的 src
                        that.$refs.fileInput.value = "";
                    };
                    reader.readAsDataURL(file); // 读取文件数据为 Data URL
                }
            }
        },
        //压缩图片
        compressImage(event){
            var that = this
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = function(e) {
                const img = new Image();
                img.src = e.target.result;

                img.onload = function() {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // 保持原始尺寸
                    canvas.width = img.width;
                    canvas.height = img.height;

                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    // 将canvas内容转为Blob对象，并设置压缩质量
                    canvas.toBlob(function(blob) {

                        // 将Blob对象转换为File对象
                        const compressedFile = new File([blob], 'compressed_image.jpg', { type: 'image/jpeg' });

                        // 输出File对象
                        //console.log(compressedFile);
                        that.file = [compressedFile]
                        // that.file.push(compressedFile)
                        that.uploadService()

                    }, 'image/jpeg', 0.75); // 第二个参数是图片类型，第三个参数是压缩质量
                };
            };

            reader.readAsDataURL(file);
        },
        //保存图片到服务器
        async uploadService(){
            if(this.isUpload){
                this.isUpload=false
                let info = {
                    name:this.user.name,
                    token:this.user.token
                }
                const formData = new FormData();
                formData.append("files", this.file[0]);
                formData.append('info',JSON.stringify(info));
                let res=await axios.post('https://service.oxvatech.cn/diy/upload',formData,{headers: {
                       'Content-Type': 'multipart/form-data'
                }});
                if(res.status == 200){
                    this.serveLink = res.data.files[0].path
                    this.isUpload=true
                    if(this.isClickDownload){
                        this.captureScreenshot()
                    }
                }else{
                    showMessage('Upload failed, please try again','error')
                    this.isUpload=true
                }
            }
            
        },
        // 发送邮箱验证
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.user.email)){
                    if(!this.sendFlag){
                        this.sendText = 'Has sent'
                        this.sendFlag = true
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.user));
                        let res = await axios.post('https://service.oxvatech.cn/diy/sendEmail',params);
                        if(res.data.status == 200){
                            this.isSend = true
                            showMessage('Email has been sent, please check.','success')
                        }
                    }else{
                        showMessage('Sent, please try again in one minute.','success')
                        setTimeout(() => {
                            this.sendFlag = false
                            this.sendText = 'Send code'
                        }, 1000*60);
                    }
                    
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        //登录
        async loginActivity(){
            if(this.isSend){
                if(this.user.name == '' || this.user.email == '' || this.user.country == 'Country' || this.user.code == ''){
                    showMessage('Please fill in the information completely','error')
                }else{
                    // 邮箱正则表达式
                    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(emailReg.test(this.user.email)){
                        //避免重复提交
                        if(!this.loginFlag){
                            this.loginFlag = true
                            var params=new URLSearchParams();
                            params.append('info',JSON.stringify(this.user));
                            let res = await axios.post('https://service.oxvatech.cn/diy/loginActivity',params);
                            if(res.data.status == 200){
                                this.isLogin = true
                                this.setCookie('_oxva_diy_',res.data.data,90)
                                showMessage('Login successful','success')
                                this.popup = this.loginPopup = false
                                setTimeout(() => {
                                    location.reload()
                                }, 500);
                            }else if(res.data.status == 201){
                                this.loginFlag = false
                                showMessage('Email verification code error','error')
                            }else if(res.data.status == 202){
                                this.loginFlag = false
                                showMessage('Username already exists','error')
                            }  
                        }
                    }else{
                        showMessage('Email format error','error')
                    }
                }
            }else{
                showMessage('Please send the email verification code first','error')
            }
        },
        //用于登录后刷新页面时获取用户信息
        async getInfo(){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({token:this.user.token}));
            let res = await axios.post('https://service.oxvatech.cn/diy/getInfo',params);
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    this.isLogin = true
                    this.user = res.data.data[0]
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        eventEnd(){
            showMessage('The event has ended, thank you for your participation.','success') 
        }
    },
    created(){
        //提前加载图片
        const preloadImages = () => {
            for(let i=1;i<21;i++){
                var img = new Image();
                img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/diy_box1_${i}.avif`;
            }
            for(let i=1;i<17;i++){
                var img = new Image();
                img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro_${i}.avif`;
                var img2 = new Image();
                img2.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimpro2_${i}.avif`;
                var img3 = new Image();
                img3.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimgo_${i}.avif`;
                var img4 = new Image();
                img4.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlimsqpro_${i}.avif`;
                var img5 = new Image();
                img5.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/vprime_cover_${i}.avif`;
                var img6 = new Image();
                img6.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nexlim_${i}.avif`;
            }
        };
        preloadImages()
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        this.user.token = this.getCookie('_oxva_diy_')
        if(this.user.token != ''){
            //this.isLogin = true
            //获取用户信息
            //this.getInfo()
        }

        //this.getCountry()
    },
    mounted(){

        window.addEventListener("wheel", this.handleWheel,{ passive: false });

        if(window.innerWidth>750){
            var Wflag = true
        }else{
            Wflag = false
            this.MdiyShow1 = true
            this.MdiyShow2 = false
        }

        new Swiper('.pbox1Swiper', {
            slidesPerView: 2,
            centeredSlides: true,
            loop:true,
            pagination: {
                el: '.pbox1Swiper-pagination',
            },
        }) 
 
        if(Wflag){
            ScrollTrigger.create({
                trigger:'.box1',
                start:'top+=5% top',
                end:'+=200%',
                pin:true,
                // markers:true,
                onUpdate:(self)=>{
                    let index = Math.floor(self.progress * 20);
                    if(index==0){
                        index=1
                    }
                    $('.box1_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/diy_box1_${index}.avif`);
                    $('.box1_icon').toggleClass('showup',index>17)
                    if(index>1){
                        $('.box1_icon2').hide()
                    }else{
                        $('.box1_icon2').show()
                    }
                }
            })
            
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top top+=6%',
                end:'+=250%',
                pin:true,
                scrub:true,
                // markers:true,
                onUpdate:(self)=>{
                    let index = Math.floor(self.progress * 100);
                    $('.box2_bg').toggleClass('box2bg_active',index>10)
                    $('.box2_product').toggleClass('box2pt_active',index>10)
                    $('.box2_title').toggleClass('showup',index>20)
                    $('.box2_items div:nth-child(1)').toggleClass('showup',index>30)
                    $('.box2_items p:nth-child(2)').toggleClass('showup',index>40)
                    $('.box2_items div:nth-child(3)').toggleClass('showup',index>40)
                    $('.box2_items p:nth-child(4)').toggleClass('showup',index>50)
                    $('.box2_items div:nth-child(5)').toggleClass('showup',index>50)
                    $('.box2_items p:nth-child(6)').toggleClass('showup',index>60)
                    $('.box2_items div:nth-child(7)').toggleClass('showup',index>60)
                    $('.box2_btn').toggleClass('showup',index>70)
                }
            })

            ScrollTrigger.create({
                trigger:'.diyMain',
                start:'top top+=6%',
                end:'+=100%',
                pin:true,
                // markers:true,
            })
        }else{
            gsap.from('.box2_content',{
                y:'2rem',opacity:0,duration:0.5,
                scrollTrigger:{
                    trigger:'.box2_content',
                    start:'top bottom-=30%',
                    end:'+=0',
                    toggleActions:'play none none reverse'
                }
            })
        }
    }
})

